module.exports = __webpack_public_path__ + "static/img/doge.d62b9a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search-engines/doge.png
// module id = Almo
// module chunks = 1